/* global femcare, axios */

femcare.product.panel.info.shop = {
    $mainPanel: $('.product-main--shop').not('.modal--quick-buy .product-main'),
    $notificationModal: $('.modal--cart-notification'),
    $productMedia: null,
    mediaPanel: null,
    sku: null,
    selectedOptions: {},
    defaultShopItemLimit: 50,
    $counter: null,
    $activePanel: null,
    ean: null,
    url: null,
    antiforgeryToken: null,

    /**
     * Initializes the main panel detail if it exists.
     */
    init () {
        if (this.$mainPanel.length) {
            this.initMainPanelDetail();
        }
    },

    /** Initializes the primary product and its out-of-stock dialog. */
    initMainPanelDetail () {
        this.initProductPanel(this.$mainPanel);
        this.initOutOfStockModal();
    },

    /**
     * Initializes shared product controls for the PDP or Quick Buy.
     * @param {jQuery} $productPanel - Product container.
     * @param {boolean} isQuickBuy - Whether cart events originate from Quick Buy.
     */
    initProductPanel ($productPanel, isQuickBuy = false) {
        this.mediaPanel = femcare.product.panel.media;
        this.ean = $productPanel.attr('data-ean');
        this.url = $productPanel.attr('data-product-url');
        this.sku = { skuId: $productPanel.attr('data-initial-sku') };
        $productPanel.data('productSku', this.sku);
        this.$counter = $productPanel.find('.counter');
        this.antiforgeryToken = femcare.product.cart.getAntiforgeryToken();
        this.$productMedia = $productPanel.find('.product-main__media-panel');
        this.$activePanel = $productPanel;

        this.mediaPanel.init($productPanel);
        femcare.tooltip.init();
        this.initCounter();
        this.initAddToCart(isQuickBuy, $productPanel);
        this.initSkuOptions($productPanel);
    },

    initCounter () {
        this.$counter.counter({ max: parseInt(this.$counter.attr('data-max'), 10) });
    },

    getScopedPanel ($panel) {
        if ($panel && $panel.length) {
            return $panel;
        }

        if (this.$activePanel && this.$activePanel.length) {
            return this.$activePanel;
        }

        return this.$mainPanel;
    },

    initSkuOptions ($panel) {
        const $scopedPanel = this.getScopedPanel($panel);
        const $selectMenuWidgets = $scopedPanel.find('.product-main-options .form-group--product-radio-group');

        $selectMenuWidgets.each((index, element) => {
            const $select = $(element);
            const optionName = $select.data('option-name') || $select.attr('id');
            this.selectedOptions[optionName] = $select.find('input:checked').val();

            $select.find('input').off('change.productSku').on('change.productSku', (e) => {
                const selectedInput = e.target;
                this.selectedOptions[optionName] = selectedInput.value;
                this.loadSku($scopedPanel);
            });
        });
    },

    /**
     * Refreshes SKU information and updates various components based on the new SKU data.
     * @param {object} sku - The SKU object.
     * @param {object} res - The response object.
     */
    refreshSku (sku, res, $panel) {
        const $scopedPanel = this.getScopedPanel($panel);

        this.updateSkuName(sku.productSkuName, $scopedPanel);
        this.updateSkuPrice(sku.priceInformation, $scopedPanel);
        this.updateAddToCart(sku.productQuantity, $scopedPanel);
        this.updateSkuVariationOptions(sku, $scopedPanel);
        this.updateSkuOutOfStock(res);
        this.replaceSkuSlides(sku, $scopedPanel);
        this.mediaPanel.init($scopedPanel);
    },

    /**
     * Updates the displayed SKU name.
     * @param {string} name - The SKU name.
     */
    updateSkuName (name, $panel) {
        this.getScopedPanel($panel).find('.product-main__name').text(name);
    },

    /**
     * Updates the displayed SKU price information.
     * @param {object} price - The price information.
     */
    updateSkuPrice (price, $panel) {
        const $scopedPanel = this.getScopedPanel($panel);
        const $strikethroughPrice = $scopedPanel.find('.product-main-purchase__amount--old');
        const $price = $scopedPanel.find('.product-main-purchase__amount--new');

        if (price.showDiscount) {
            $strikethroughPrice.text(price.priceWithoutDiscount);
            $strikethroughPrice.show();
            $price.text(price.sellingPrice);
        } else {
            $strikethroughPrice.text('');
            $strikethroughPrice.hide();
            $price.text(price.priceWithoutDiscount);
        }
    },

    /**
     * Initializes "Add to Cart" functionality and sets up the event listener for the "Add to Cart" button.
     * @param {boolean} isQuickBuy - Whether cart events originate from Quick Buy.
     */
    initAddToCart (isQuickBuy, $panel) {
        const $scopedPanel = this.getScopedPanel($panel);
        const $addToCart = $scopedPanel.find('.product-cart-add__button');

        $addToCart.off('click.productAddToCart').on('click.productAddToCart', () => {
            const count = $scopedPanel.find('.counter').counter('getCount');
            const sku = $scopedPanel.data('productSku') || { skuId: $scopedPanel.attr('data-initial-sku') };

            const data = {
                ean: $scopedPanel.attr('data-ean'),
                url: $scopedPanel.attr('data-product-url'),
                id: sku.productSkuId || sku.skuId,
                variationAttributes: this.getVariationAttributes($scopedPanel),
                quantity: count
            };

            femcare.loader.toggleLoader(this.$notificationModal[0], true);

            $.ajax({
                url: femcare.shared.util.baseUrl + 'ajax/products/product/addItemToBag',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
                success: (res) => {
                    if (res.success) {
                        const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                        const product = contentData.product;
                        const checkoutUrl = contentData.checkoutUrl;

                        femcare.loader.toggleLoader(this.$notificationModal[0], false);
                        this.refreshCartCount(this.antiforgeryToken);
                        femcare.product.cart.displayAddedNotification(product, checkoutUrl);
                        this.updateCartNotificationSuggestedProducts(res);
                        femcare.shared.rangeSlider.init();

                        femcare.tracking.product.ecommAddProductToCart(product, count, isQuickBuy);

                    }
                },
                error: () => {
                    femcare.loader.toggleLoader(this.$notificationModal[0], false);
                }
            });
        });
    },

    /**
     * Refreshes the displayed cart count and publishes a notification about the updated cart item count.
     * @param {String} protectionToken - antiforgery token
     */
    refreshCartCount (protectionToken) {
        femcare.loader.toggleLoader(this.$notificationModal[0], true);

        return $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getbag?onlyTotal',
            dataType: 'json',
            method: 'GET',
            headers: { 'X-Request-Verification-Token': protectionToken },
            success: (res) => {
                const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                const cartItemCount = (contentData && contentData.totalItems) || 0;
                femcare.shared.pubsub.publish('CART_ITEM_COUNT_UPDATED', cartItemCount);
            },
            complete: () => {
                femcare.loader.toggleLoader(this.$notificationModal[0], false);
            }
        });
    },

    /**
     * Updates the "Add to Cart" button based on the available quantity.
     * @param {object} quantity - The quantity information.
     */
    updateAddToCart (quantity, $panel) {
        const $scopedPanel = this.getScopedPanel($panel);
        const $counter = $scopedPanel.find('.counter');
        const availableQuantity = parseInt(quantity.max, 10);
        $scopedPanel
            .find('.product-unavailable__message--availability')
            .text(quantity.availability.stockMessage);

        if (availableQuantity > 0 && quantity.available !== false &&
            quantity.availability.itemAvailability !== 'OutOfStock') {
            const minimumQuantity = Number(quantity.min) || 1;
            const maximumQuantity = Math.min(this.defaultShopItemLimit, availableQuantity);
            const initialQuantity = Math.max(minimumQuantity, Number(quantity.initial) || minimumQuantity);
            $counter.counter('option', 'min', minimumQuantity);
            $counter.counter('setMax', maximumQuantity);
            $counter.counter('setCount', Math.min(initialQuantity, maximumQuantity));
            this.toggleOutOfStockMessage(false, $scopedPanel);
        } else {
            this.toggleOutOfStockMessage(true, $scopedPanel);
        }
    },

    /**
     * Toggles the visibility of the out-of-stock message.
     * @param {boolean} show - Indicates whether to show the message.
     */
    toggleOutOfStockMessage (show, $panel) {
        const $mainPanel = this.getScopedPanel($panel);
        const $addButton = $mainPanel.find('.product-cart-add__button');
        const $counter = $mainPanel.find('.product-cart-add__counter');
        const $message = $mainPanel.find('.product-unavailable');
        const $stash = $mainPanel.find('.product-stash-add');

        if (show) {
            $addButton.hide();
            $counter.hide();
            $stash.hide();
            $message.show();
        } else {
            $addButton.show();
            $counter.show();
            $stash.show();
            $message.hide();
        }
    },

    /**
     * Loads and updates SKU information based on the selected options.
     */
    loadSku ($panel) {
        const $scopedPanel = this.getScopedPanel($panel);
        const quickBuyRequestId = $scopedPanel.data('quickBuyRequestId');
        const $productMedia = $scopedPanel.find('.product-main__media-panel');
        const data = {
            ean: $scopedPanel.attr('data-ean'),
            url: $scopedPanel.attr('data-product-url'),
            variationAttributes: this.getVariationAttributes($scopedPanel)
        };

        femcare.loader.toggleLoader($productMedia[0], true);

        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/detailproductsku',
            method: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
            success: (res) => {
                if (quickBuyRequestId !== $scopedPanel.data('quickBuyRequestId')) {
                    return;
                }
                const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                const product = contentData.product;

                if (product) {
                    this.sku = product;
                    $scopedPanel.data('productSku', product);
                    this.refreshSku(this.sku, res, $scopedPanel);
                    this.updateOutOfStockTitle(product.productQuantity.availability, $scopedPanel);
                } else {
                    $scopedPanel.find('.product-cart-add__counter').hide();
                    $scopedPanel.find('.product-cart-add__button').hide();
                    $scopedPanel.find('.product-main-options .form-group--product-radio-group input').each((index, element) => {
                        $(element).removeAttr('disabled');
                    });
                }

                femcare.tracking.product.eccomViewProductVariantAnalytics(product);
            },
            complete: () => {
                if (quickBuyRequestId === $scopedPanel.data('quickBuyRequestId')) {
                    femcare.loader.toggleLoader($productMedia[0], false);
                }
            }
        });
    },

    /**
     * Resets the selected options of the product object to an empty state.
     */
    resetSelectedOptions () {
        this.selectedOptions = {};
    },

    /**
     * Retrieves and returns an array of selected variation attributes.
     * @returns {Array} - The variation attributes array.
     */
    getVariationAttributes ($panel) {
        if ($panel && $panel.length) {
            return $panel.find('.product-main-options .form-group--product-radio-group').map((index, element) => {
                const $select = $(element);

                return {
                    name: $select.data('option-name') || $select.attr('id'),
                    value: $select.find('input:checked').val()
                };
            }).get();
        }

        const variationAttributes = [];

        for (const key in this.selectedOptions) {
            if (Object.prototype.hasOwnProperty.call(this.selectedOptions, key)) {
                variationAttributes.push({
                    name: key,
                    value: this.selectedOptions[key]
                });
            }
        }

        return variationAttributes;
    },

    /**
     * Replaces the existing SKU slides with new ones based on the provided SKU data.
     * @param {object} sku - The SKU object.
     */
    replaceSkuSlides (sku, $panel) {
        const $scopedPanel = this.getScopedPanel($panel);
        const $mainSlides = $scopedPanel.find('.product-main__slides');
        const $thumbnailSlides = $scopedPanel.find('.product-main__thumbnails');
        const zoomInAsset = $mainSlides.attr('data-zoom-in');
        const zoomOutAsset = $mainSlides.attr('data-zoom-out');

        $scopedPanel.find('.swiper').each(function () {
            this.swiper?.destroy(true, true);
        });

        const $tempMainSlideContainer = $('<div></div>');
        const $tempThumbnailContainer = $('<div></div>');

        sku.images.forEach((image) => {
            const $mainSlide = $('<div class="product-main__slide swiper-slide"></div>');
            const $zoomContainer = $('<div class="swiper-zoom-container"></div>');
            const $zoomTarget = $('<div class="swiper-zoom-target"></div>');

            const $standardImageWrapper = $('<div class="product-main__image product-main__image--standard"></div>');
            $standardImageWrapper.css('cursor', 'url(' + zoomInAsset + ') 17.5 17.5, pointer');
            const $standardImage = $('<img loading="lazy"/>');
            $standardImage.attr('src', image.url);
            $standardImage.attr('alt', image.altText || '');
            $standardImageWrapper.append($standardImage);
            $zoomTarget.append($standardImageWrapper);

            const $largeImageWrapper = $('<div class="product-main__image product-main__image--large"></div>');
            $largeImageWrapper.css('cursor', 'url(' + zoomOutAsset + ') 17.5 17.5, pointer');
            const $largeImage = $('<img loading="lazy"/>');
            $largeImage.attr('src', image.zoomUrl || image.url);
            $largeImage.attr('alt', image.altText || '');
            $largeImageWrapper.append($largeImage);
            $zoomTarget.append($largeImageWrapper);

            $zoomContainer.append($zoomTarget);
            $mainSlide.append($zoomContainer);
            $tempMainSlideContainer.append($mainSlide);

            const $thumbnailSlide = $('<li class="product-main__thumbnail swiper-slide"></li>');
            const $thumbnailImage = $('<img>').attr({ src: image.url, alt: image.altText || '' });
            $thumbnailSlide.append($thumbnailImage);
            $tempThumbnailContainer.append($thumbnailSlide);
        });

        $mainSlides
            .empty()
            .append($tempMainSlideContainer.html());

        $thumbnailSlides
            .empty()
            .append($tempThumbnailContainer.html());
    },

    /**
     * Initializes the out-of-stock modal and sets up event listeners for the modal interaction.
     */
    initOutOfStockModal () {
        const $modal = $('#outOfStockModal');
        const $notificationForm = $modal.find('.product-unavailable__form');
        const $modalTitle = $modal.find('.modal__title');
        const $modalBody = $modal.find('.modal__body');

        // Store original title and body so we can restore them later
        const originalTitle = $modalTitle.text();
        const originalBody = $modalBody.html();

        $notificationForm.on('submit', (e) => {
            e.preventDefault();

            const formData = new FormData($notificationForm[0]);
            const postData = {};

            formData.forEach((value, key) => {
                postData[key] = value;
            });

            postData.ean = this.ean;
            postData.url = this.url;
            postData.variationAttributes = this.getVariationAttributes();

            axios.post(
                femcare.shared.util.baseUrl + 'ajax/products/product/notifyMe',
                postData,
                {
                    headers: {
                        'X-Request-Verification-Token': this.antiforgeryToken,
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }
            )
                .then((res) => {
                    if (res.data && res.data.success) {
                        // Update title and body content with response and remove submit button
                        $modalTitle.text(res.data.heading);
                        $modalBody.html(res.data.body);
                        $notificationForm.find('button[type="submit"]').remove();
                    }
                })
                .catch((err) => {
                    console.error('Notify me request failed', err);
                });
        });

        // Restore modal content when it's closed
        $modal.on('transitionend', () => {
            if (!$modal.hasClass('displayed')) {
                $modalTitle.text(originalTitle);
                $modalBody.html(originalBody);
            }
        });
    },

    /**
     * Updates the SKU variation options based on the provided SKU data.
     * @param {object} sku - The SKU object.
     */
    updateSkuVariationOptions (sku, $panel) {
        const $scopedPanel = this.getScopedPanel($panel);

        if (!sku.optionGroups) {
            return;
        }

        sku.optionGroups.forEach((optGroup) => {
            optGroup.values.forEach((optValue) => {
                const option = $scopedPanel.find('.form-group--product-radio-group').filter(function () {
                    return ($(this).data('option-name') || this.id) === optGroup.label;
                }).find('input').filter(function () {
                    return this.value === optValue.value;
                });
                option.removeAttr('disabled');
                option.removeAttr('checked');
                if (optValue.selected) {
                    option.prop('checked', true);
                }
                if (optValue.disabled) {
                    option.prop('disabled', true);
                }
            })
        })
    },

    /**
     * Updates SKU out-of-stock information and renders suggested products if available.
     * @param {object} res - The response object.
     */
    updateSkuOutOfStock (res) {
        if (res.suggestedProductsRendered) {
            window.pr_render_options_sp = [];

            $('.suggested-products__slider').replaceWith(res.suggestedProductsRendered);
            femcare.product.panel.info.slider.init();
            this.renderPowerReviews();
        }
    },

    /**
     * Updates the text of the out-of-stock title based on the provided availability information.
     * @param {Object} availability - The availability object containing stock information.
     */
    updateOutOfStockTitle (availability, $panel) {
        const $outOfStockTitle = this.getScopedPanel($panel).find('.product-main__out-of-stock--title');

        if (availability && availability.itemAvailability === 'OutOfStock' && availability.stockMessage) {
            $outOfStockTitle.text(availability.stockMessage);
        } else {
            $outOfStockTitle.text('');
        }
    },

    /**
     * Updates suggested products in the cart notification area based on the provided response.
     * @param {object} res - The response object.
     */
    updateCartNotificationSuggestedProducts (res) {
        if (res.suggestedProductsRendered) {
            window.pr_render_options_sp = [];

            $('.cart-suggested').replaceWith(res.suggestedProductsRendered);
            this.renderPowerReviews();
        }
    },

    /**
     * Renders PowerReviews if the library is loaded.
     */
    renderPowerReviews () {
        const isPowerReviewsLoaded = window.POWERREVIEWS;
        if (isPowerReviewsLoaded) {
            const pr_render_options_sp = window.pr_render_options_sp || [];
            window.POWERREVIEWS.display.render(pr_render_options_sp);
        }
    }
};
